





































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import BaseComponent from '@/core/base.component';
import { MenuUpdateDto, MenuDto } from '@/dto';
import MenuService from '../../../services/menu.service';
import toast from '../../../../resources/assets/js/services/toast.js';
import { CONST_YN, YN } from '@/common';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';
import draggable from 'vuedraggable';

@Component({ name: 'MenuUpdate' })
export default class MenuUpdate extends BaseComponent {
  private menuUpdateDto = new MenuUpdateDto();
  private menuDto = new MenuDto();
  private updateMenuNo = null;
  private showYn: YN[] = [...CONST_YN];
  private uploadImages: FileAttachmentDto[] = [];
  private newImages: FileAttachmentDto[] = [];
  private selectedImages = [];
  private dataLoading = false;

  // delete images
  deleteNewImages(image, index) {
    if (this.newImages.includes(image)) {
      index = this.newImages.indexOf(image);
      if (index > -1) {
        this.newImages.splice(index, 1);
      }
    }
  }

  deleteOldImages(image, index) {
    if (this.uploadImages.includes(image)) {
      index = this.uploadImages.indexOf(image);
      if (index > -1) {
        this.uploadImages.splice(index, 1);
      }
    }
  }

  // 이미지 업로드
  async upload(file: File[]) {
    this.dataLoading = true;
    const attachments = await FileUploadService.upload(UPLOAD_TYPE.MENU, file);
    this.newImages = [];
    this.newImages.push(
      ...attachments.filter(
        fileUpload =>
          fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );

    this.dataLoading = false;
  }

  clearOutUpdateDto() {
    this.menuUpdateDto = new MenuUpdateDto();
    this.newImages = [];
  }

  findOne(menuNo) {
    MenuService.findOne(menuNo).subscribe(res => {
      this.menuUpdateDto = res.data;
      this.uploadImages = res.data.images;
      this.newImages = [];
    });
  }

  update() {
    if (this.uploadImages && this.uploadImages.length > 0) {
      this.menuUpdateDto.images = this.uploadImages;
      this.menuUpdateDto.newImages = this.newImages;
    }
    if (
      this.uploadImages &&
      this.uploadImages.length < 1 &&
      this.newImages &&
      this.newImages.length > 0
    ) {
      this.menuUpdateDto.images = [];
      this.menuUpdateDto.newImages = this.newImages;
    }
    if (
      this.uploadImages &&
      this.uploadImages.length < 1 &&
      this.newImages &&
      this.newImages.length < 1
    ) {
      this.menuUpdateDto.newImages = [];
      this.menuUpdateDto.images = [];
    }

    if (
      this.uploadImages &&
      this.uploadImages.length < 1 &&
      this.newImages &&
      this.newImages.length > 0
    ) {
      this.menuUpdateDto.images = this.newImages;
      this.menuUpdateDto.newImages = [];
    }

    // if (this.newImages && this.newImages.length < 1) {
    //   this.menuUpdateDto.images = this.uploadImages;
    //   this.menuUpdateDto.newImages = [];
    // }
    console.log(this.menuUpdateDto);
    MenuService.update(this.updateMenuNo, this.menuUpdateDto).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.$root.$emit('menu_create');
      }
    });
  }

  mounted() {
    this.$root.$on('menu_update', menuNo => {
      this.updateMenuNo = menuNo;
      this.findOne(menuNo);
    });
  }
}
